import { createFileRoute } from '@tanstack/react-router'
import { CatalogPreviewBookingPage } from '@/routes/book/$operatorSlug'

export const Route = createFileRoute('/services/$catalogId/preview')({
  component: CatalogPreviewRoute,
})

function CatalogPreviewRoute() {
  const { catalogId } = Route.useParams()

  return <CatalogPreviewBookingPage catalogId={catalogId} />
}
